export default __webpack_public_path__ + "static/media/CSAQRnoshad.ed415e21.png";